import { PREVIEW_GATEWAY_PATH_STORAGE_KEY as LS_KEY } from "utils/localStorage";
import { ENV } from "utils/hostEnv";
import { PROD } from "utils/config";

const GATEWAY_PARAM = "gateway";
const PR_PATTERN = /^pr-\d+$/;

// Resolved once at module load: a `?gateway=pr-<n>` param seeds and persists
// the selection, otherwise it falls back to whatever was persisted last
// session. Deliberately synchronous — `api/client.ts` reads this on every
// request and must never await anything to do it. Dev/staging only: prod
// never reads or writes this, regardless of what's in the URL or storage.
function resolvePath(): string | null {
  if (ENV.NAME === PROD) return null;

  const pr = new URLSearchParams(window.location.search).get(GATEWAY_PARAM);
  if (pr && PR_PATTERN.test(pr)) {
    const path = `/api/preview/${pr}`;
    try {
      localStorage.setItem(LS_KEY, path);
    } catch {
      /* ignore */
    }
    return path;
  }
  try {
    return localStorage.getItem(LS_KEY);
  } catch {
    return null;
  }
}

const path = resolvePath();

export const getPreviewGatewayPath = (): string | null => path;

export const getPreviewGatewayPr = (): string | null =>
  path?.match(/^\/api\/preview\/(pr-\d+)$/)?.[1] ?? null;

// Clears the selection and reloads. Also strips the `gateway` param from the
// URL, not just storage — otherwise reloading the URL that set it would just
// read it again and put the same path right back.
export const continueWithLiveGateway = () => {
  try {
    localStorage.removeItem(LS_KEY);
  } catch {
    /* ignore */
  }
  const url = new URL(window.location.href);
  url.searchParams.delete(GATEWAY_PARAM);
  window.location.href = url.toString();
};
